<!-- Translated: yes -->
<template>
  <Modal @close="closeModal" :wide="false" width="650px" set-class="no-padding">

    <h2>{{ $t('skipass.pricelist-title') }}</h2>

    <div class="tab-buttons" v-if="showTabs">
      <button :class="'small ' + (activeTab === 'weekday' ? 'blue' : 'white') + ' border'" @click="switchTab('weekday')">Vardag</button>
      <button :class="'small ' + (activeTab === 'weekend' ? 'blue' : 'white') + ' border'" @click="switchTab('weekend')">Helg</button>
      <button :class="'small ' + (activeTab === 'premiere' ? 'blue' : 'white') + ' border'" @click="switchTab('premiere')">Premiärhelg</button>
    </div>

    <table>

      <thead>
        <th></th>
        <th class="special-price-wrapper--title"></th>
        <th v-if="SITE_CONFIG.site !== 'branas' && SITE_CONFIG.site !== 'kungsberget'"><b>Barn</b><br />{{ SITE_CONFIG.skipass.ages.children }}&nbsp;år</th>
        <th><b>{{ $t('general.ages.youth') }}</b><br />{{ SITE_CONFIG.skipass.ages.youths }}år</th>
        <th><b>{{ $t('general.ages.adult') }}</b><br />{{ SITE_CONFIG.skipass.ages.adults }}år</th>
        <th v-if="SITE_CONFIG.skipass.ages.seniors"><b>{{ $t('general.ages.senior') }}</b><br />{{ SITE_CONFIG.skipass.ages.seniors }}år</th>
        <th><b>{{ $t('skipass.cards.parents') }}</b><br />&nbsp;</th>
      </thead>

      <tbody>
        <tr v-for="(price, key) in prices" v-if="titles[key] && (price.youths || price.adults || price.parents)">
          <td class="title"><b>{{ titles[ key ] }}</b></td>
          <td class="special-price-wrapper"><span class="special-price" v-if="price.special_text">{{ price.special_text }}</span></td>
          <td class="price" v-if="SITE_CONFIG.site !== 'branas' && SITE_CONFIG.site !== 'kungsberget'"><span v-if="price.children">{{price.children.price | currency}}</span></td>
          <td class="price"><span v-if="price.youths">{{price.youths.price | currency}}<span v-if="price.youths.asterisk">{{price.youths.asterisk}}</span></span></td>
          <td class="price"><span v-if="price.adults">{{price.adults.price | currency}}<span v-if="price.adults.asterisk">{{price.adults.asterisk}}</span></span></td>
          <td v-if="SITE_CONFIG.skipass.ages.seniors" class="price"><span v-if="price.seniors">{{price.seniors.price | currency}}<span v-if="price.seniors.asterisk">{{price.seniors.asterisk}}</span></span></td>
          <td class="price" v-if="SITE_CONFIG.site === 'branas' || SITE_CONFIG.site === 'kungsberget'"><span v-if="price.parents">{{price.parents.price | currency}}<span v-if="price.parents.asterisk">{{price.parents.asterisk}}</span></span></td>
        </tr>
      </tbody>

    </table>

    <div class="padding">
      <p v-for="asterisk in asterisks">
        <span v-html="asterisk.asterisk + ' ' + asterisk.text"></span>
      </p>
    </div>

  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';

import API from '@/classes/API';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
  },
  data() {
    return {
      prices: [],
      asterisks: [],
      titles: {},
      activeTab: 'weekday',
    };
  },
  async mounted() {
    await this.reload();
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
    switchTab(tab) {
      this.activeTab = tab;
      this.reload();
    },
    async reload() {
      const { data, titles, asterisks } = await API.get(`skipass/list?date=${this.fakeDate}`);
      this.titles = titles;
      this.prices = data;
      this.asterisks = asterisks;
    },
  },
  computed: {
    showTabs() {
      return this.SITE_CONFIG.skipass.has_weekend_prices
        || this.SITE_CONFIG.skipass.has_premiere_prices;
    },
    fakeDate() {
      if (this.activeTab === 'weekday') {
        return this.SITE_CONFIG.skipass.fake_weekday_date;
      } else if (this.activeTab === 'weekend') {
        return this.SITE_CONFIG.skipass.fake_weekend_date;
      } else if (this.activeTab === 'premiere') {
        return this.SITE_CONFIG.skipass.fake_premiere_date;
      }

      return '';
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

h2
  font-size: 18px;
  font-weight: 900;
  text-align: center;
  color: #262626;
  united-heavy()
  uppercase()
  margin-top: 14px
  margin-bottom: 14px

.tab-buttons
  display: flex
  justify-content: center
  margin-bottom: 1rem
  button
    margin: 0 0.125rem

table
  width 100%
  thead
    th
      background-color: #005580;
      color white
      padding 6px 0 6px 25px
      font-size: 10px;
      font-weight: 300;
      padding-right: 10px
      padding-left: 20px
      text-align: right
      &:first-child
        padding-left: 20px
      &:last-child
        padding-right: 20px
      &.special-price-wrapper--title
        +max-mobile()
          display: none
      b
        united-heavy()
        uppercase()
        font-size: 14px
        display: inline-block;
  tbody
    tr
      background-color: white;
    tr:nth-child(odd)
      background-color: #f9f9f9;
    td
      padding 6px 40px 6px 25px
      text-align: left;
      &.title
        padding-right: 25px
      &.special-price-wrapper
        width 50px
        padding 0
        padding-right: 25px
        +max-mobile()
          display none
      .special-price
        border-radius: 3px;
        background-color: #d68605;
        padding 6px 9px
        font-size: 9px;
        color: white
        text-transform: uppercase;
        font-weight: bold;
      &.price
        text-align: right
        padding-right: 10px
        padding-left: 20px
      &:first-child
        padding-left: 20px
      &:last-child
        padding-right: 20px
      +max-mobile()
        padding: 9px 20px 9px 15px

.padding
  padding 25px 25px 15px 25px

</style>



// WEBPACK FOOTER //
// SkipassPrices.vue?066bc6d4